import type { ReactElement } from "react"
import React, { useMemo, useState } from "react"
import SearchSuggestion from "shared/components/SearchSuggestion"

import useInstructionsSuggestionList from "@/screens/Products/components/Product/Instructions/hooks/useInstructionsSuggestionList"
import type { AutocompleteOption } from "@/types/form-fields"
import useDebounce from "@/utils/useDebounce"

const InstructionSearchSuggestion = ({
  onSearch,
}: {
  onSearch: (searchedItem: string | AutocompleteOption) => void
}): ReactElement => {
  const [inputValue, setInputValue] = useState("")
  const debouncedSearchTerm = useDebounce(inputValue, 300)
  const { instructions, fetching } = useInstructionsSuggestionList({
    query: debouncedSearchTerm,
  })

  const options = useMemo(() => {
    if (fetching) return []
    return (instructions?.map((i) => ({
      label: i?.name ?? `instruction with id ${i?.instructionId}`,
      id: i?.instructionId,
    })) || []) as AutocompleteOption[]
  }, [instructions, fetching])

  return (
    <SearchSuggestion
      onSearch={onSearch}
      placeholder='Search by Instruction Name or Description'
      inputValue={inputValue}
      setInputValue={setInputValue}
      options={options}
      fetching={fetching}
    />
  )
}

export default InstructionSearchSuggestion
